import React from 'react';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import ExploreOffersModuleView from './ExploreOffersModuleView';
import { filterBusinessTitle } from 'helpers/common';

export const ExploreOffersModuleController = props => {
  const loading = props?.globalLoadingFlag;

  const { tiles, eventHandler, creditInfo } = props;
  const offersTilesFilter = filterBusinessTitle(creditInfo, tiles);

  if (loading) {
    return <LoadingMask />;
  } else {
    return (
      <ExploreOffersModuleView
        tiles={offersTilesFilter}
        eventHandler={eventHandler}
        modulePosition={props.modulePosition}
        config={props?.config}
      />
    );
  }
};
